<div class="fx-col page-padding page-content fx-gap-20">
  <app-crud-table title="RETAILER BILLING DETAILS"
                  subTitle="A list of this lease's retailers and their billing status"
                  [modelType]="retailerBillingSummaryModel"
                  [loading$]="loading$"
                  [tableData]="subLeaseDetails">
  </app-crud-table>


  <div class="upload-container">
    @if (parentLease) {
      <div class="fx-row fx-center fx-space-between fx-gap-10">
        <app-csv-import #csvImport
                        [uploadDataModel]="uploadConfig"
                        [disableUpload]="disableUpload"
                        [validateFile]="true"
                        [validateEndpoint]="validateEndpoint"
                        [otpValidation]="true"
                        [otpRequestEndpoint]="otpEndpoint"
                        [uploadEndpoint]="uploadEndpoint"
                        (dataValidated)="updateDataAfterValidation($event)"
                        (dataUploaded)="updateAfterUpload($event)"
                        (columnSelected)="setAddressMap($event)"
        >
        </app-csv-import>
      </div>
    }
  </div>
</div>
